import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState, IMultiEditingCategoriesProps, IMultiEditingPickerField} from './types';
import { Context } from "routes/private/Editor/Context";
import MultiEditingFields from './fields';
import { getMultiEditingFieldsForPicker } from '@utils/multiEditing'

const MultiEditingCategories:React.FC<IMultiEditingCategoriesProps> = (props) => {
  let context = useContext(Context);
  const [fields,setFields] = useState<IMultiEditingPickerField[]>([]);
  
  useEffect(() => {
    if (context.multiEditingConfig) {
      const fieldsPicker = getMultiEditingFieldsForPicker(props.id, context.multiEditingConfig, context.data, context.selectDescribe?.taggedFields);      
      setFields(fieldsPicker);
    }
  }, [context.editorStatus.setsSelected, context.multiEditingConfig])

  return (
    <>
        {
            fields.map((field, index) => {
              return (
                  <MultiEditingFields
                    key={index}
                    id={field.id}
                    elementType={field.elementType}
                    selectDescribeFieldId={field.selectDescribeFieldId}
                    categoryId={field.categoryId}
                    name={field.name}
                  />
              )
          })
      }
    </>
  );
}

export default MultiEditingCategories;